import React, { useEffect } from "react";
import Editor from "@monaco-editor/react";

interface JsonEditorProps {
  value: any;
  onChange?: (value: any) => void;
}

export const JsonEditor: React.FC<JsonEditorProps> = ({ value, onChange }) => {
  useEffect(() => {
    console.log('JsonEditor value变化:', {
      '新value': value,
      '组件是否重新渲染': true
    });
  }, [value]);
  // 处理输入值，确保是格式化的JSON字符串
  const formatValue = (val: any): string => {
    try {
      // 如果是字符串，先尝试去除转义
      if (typeof val === "string") {
        // 先尝试解析一次，处理转义字符
        const unescaped = val.replace(/\\"/g, '"').replace(/\\n/g, "\n");
        const parsed = JSON.parse(unescaped);
        return JSON.stringify(parsed, null, 2);
      }
      // 如果不是字符串，直接格式化
      return JSON.stringify(val, null, 2);
    } catch (e) {
      // 如果解析失败，返回原始值
      return val;
    }
  };
  return (
    <Editor
      height="100%"
      defaultLanguage="json"
      value={formatValue(value)}
      onChange={onChange}
      options={{
        theme: "vs-dark",
        minimap: { enabled: false },
        formatOnPaste: true,
        formatOnType: true,
        automaticLayout: true,
        scrollBeyondLastLine: false,
        tabSize: 2,
      }}
    />
  );
};
